export default __webpack_public_path__ + "static/share-3aad98104a1b1051e01de535ab5320cd.jpg";